import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9a6c892"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-bespoke-clinical-presentation-splash" }
const _hoisted_2 = { class: "hd-bespoke-clinical-presentation-splash__columns" }
const _hoisted_3 = { class: "hd-bespoke-clinical-presentation-splash__col-one" }
const _hoisted_4 = { class: "hd-bespoke-clinical-presentation-splash__col-two" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_image_svg = _resolveComponent("base-image-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_lyra_asset, {
          class: "hd-bespoke-clinical-presentation-splash__title hd-title",
          "asset-key": `${_ctx.endpointId}.title`
        }, null, 8, ["asset-key"]),
        _createVNode(_component_lyra_asset, {
          class: "hd-bespoke-clinical-presentation-splash__subtitle hd-subtitle",
          "asset-key": `${_ctx.endpointId}.subtitle`
        }, null, 8, ["asset-key"]),
        _createElementVNode("div", {
          class: "hd-bespoke-clinical-presentation-splash__button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateTo(_ctx.getNavigationEndpoints(1))))
        }, [
          _createVNode(_component_lyra_asset, {
            "asset-key": `${_ctx.endpointId}.button`
          }, null, 8, ["asset-key"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_base_image_svg, {
          class: "hd-bespoke-clinical-resentation-splash-svg",
          source: require('!html-loader!@/ui/assets/img/clinical-outcomes-figure.svg')
        }, null, 8, ["source"])
      ])
    ])
  ]))
}